import { Option } from 'shared/components/Select/models/Option';
import { mapBuildingHeatingTypeLabel } from 'shared/constants/filters/mapBuildingHeatingTypeLabel';
import { EBuildingHeatingType } from 'shared/types/filters/advanced/buildingHeatingType';

export const buildingHeatingTypeOptions = [
  new Option(EBuildingHeatingType.Autonomous, mapBuildingHeatingTypeLabel[EBuildingHeatingType.Autonomous]),
  new Option(EBuildingHeatingType.Central, mapBuildingHeatingTypeLabel[EBuildingHeatingType.Central]),
  new Option(EBuildingHeatingType.Without, mapBuildingHeatingTypeLabel[EBuildingHeatingType.Without]),
];
